<template>
  <div class="forgot">
    <div class="forgot-title">パスワードのお問い合わせ</div>
    <!-- <div class="forgot-docs">
      「<a href = "/terms.html" target="_blank">利用規約</a>」
      「<a href = "https://www.tkhs.co.jp/about/privacy.html" target="_blank">個人情報の取り扱いについて</a>」
      <span>に同意の上ご利用ください。</span>
    </div> -->
    <!-- <el-alert
      title="パスワード再設定用メールが送信できませんでした。登録されていないメールアドレスです。正しいメールアドレスを入力してください。"
      type="error">
    </el-alert> -->
    <div class="forgot-tips">
      <p>下記にメールアドレスを入力のうえ、「送信」ボタンを押してください。</p>
      <br>
      <p>入力されたメールアドレス宛てに、新しいパスワードをお送りします。</p>
      <br>
    </div>
    <el-form ref="forgotForm" :model="form" class="app-form" :rules="rules">
      <el-form-item prop="email" label="メールアドレス" style="margin-bottom: 30px">
        <el-input v-model="form.email" autocomplete="off"
          placeholder="xxx@xxx.xxx"
          maxlength="64"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-date-picker
          v-model="form.birthday"
          type="date"
          placeholder="生年月日">
        </el-date-picker>
      </el-form-item> -->
      <el-form-item>
        <el-button class="studypack-button-primary" type="primary" @click="onSubmit">送信</el-button>
      </el-form-item>
      <a href = "" @click="loginClick">ログインはこちらへ</a>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request';
import Cookies from 'js-cookie';
import { Message } from 'element-ui'; // element-uiのメッセージボックスをインポート

export default {
  name: 'Forgot',
  data() {
    return {
      url: window.location.origin,
      form: {
        email: '',
        // birthday: '',
      },
      rules: {
        email: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '無効なメールアドレスです。', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.forgotForm.validate((valid) => {
        if (valid) {
          Cookies.remove('token');
          request('remindPassword', { url: this.url, email: this.form.email }).then((res) => {
            Message.success(res.msg);
            this.goLogin();
          });
        }
      });
    },
    loginClick() {
      this.$router.push({
        path: '/login',
        query: { manshonId: sessionStorage.getItem('sessionManshonId') },
      }).catch(() => {});
    },
    goLogin() {
      this.$router.push({
        path: "/login",
        query: { manshonId: localStorage.getItem('sessionManshonId') }
      }).catch(() => {});
    },
  },
};
</script>

<style lang="less">
.forgot {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  margin: 40px auto;
  max-width: 600px;

  .forgot-title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 24px;
  }
  .forgot-docs {
    text-align: center;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .el-alert {
    margin-bottom: 24px;
  }
  .forgot-tips {
    margin-bottom: 30px;
  }
}
</style>
